import { useFormikContext } from "formik";
import React, { FC, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import AccessGroupColumns from "../../../models/ColumnDefinitions/AccessGroupColumns";
import AccessGroupSearch from "../../../models/search/AccessGroupSearch";
import { removeColumns } from "../../../models/utilities/columnHelper";
import { getAllAccessGroups } from "../../../services/accessGroupService";
import TableTab from "../../tabs/table-tab";

interface OssGroupStepProps {
    onNext: (e: any) => void;
    onBack: (e: any) => void;
    setTotalOssGroups: React.Dispatch<React.SetStateAction<number>>;
}

const OssGroupStep: FC<OssGroupStepProps> = ({ onNext, onBack, setTotalOssGroups }) => {
    const { setFieldValue, values } = useFormikContext<any>();
    const { translate } = useLocale();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const onLocalNext = (e: any) => {
        setTotalOssGroups(selectedIds.length);
        setFieldValue("ossGroups", selectedIds);
        setFieldValue("ossGroupRows", selectedRows);
        onNext(e);
    }

    const hasAtLeastOneSelection = selectedIds.length > 0 || (values.accessGroups && values.accessGroups.length > 0) || (values.floorGroups && values.floorGroups.length > 0);

    return <div className="pt-3 pr-3 h-full flex flex-col">
        <div className="flex-1 overflow-y-auto">
            <TableContextProvider
                dataMethod={(listParameters) => getAllAccessGroups(3, translate, listParameters)}
                tableDescriptor={removeColumns(AccessGroupColumns, ['days', 'startTime', 'duration', 'enrolments', 'area', 'accessProfile'])}
                searchDescriptor={AccessGroupSearch}
                useTable
                usePagination
                useFilter
                useSearch
                useSort>
                <TableTab
                    title={translate.byKey(TranslationKeys.ossGroups)}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    cyName="ossGroupStep"/>
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end mt-4 pr-3 pb-3">
            <div className="flex flex-row">
                <button
                    className="py-1 px-5 secondary secondary-inverse"
                    type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end pl-3">
                <button
                    id="nextBtn"
                    className={`py-1 px-5 secondary ${hasAtLeastOneSelection ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type="button"
                    disabled={!hasAtLeastOneSelection}
                    onClick={onLocalNext}>
                    {translate.byKey(TranslationKeys.next)}
                </button>
            </div>
        </div>
    </div>
}

export default OssGroupStep;